var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPreviousIcon = function SvgPreviousIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 23 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M22.167 1.333A1.333 1.333 0 0 0 20 .293L6.667 10.958a1.333 1.333 0 0 0 0 2.082L20 23.708a1.333 1.333 0 0 0 2.167-1.041zM3.5 2.667a1.333 1.333 0 1 0-2.667 0v18.666a1.333 1.333 0 1 0 2.667 0z"
  })));
};
export default SvgPreviousIcon;